export enum EOrder {
  ASC = 'asc',
  DESC = 'desc',
}
